module.exports = __webpack_public_path__ + "static/media/padlock@2x.b84b50ac.svg";